var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "room-extend-menu-component",
      class: { newWindow: _vm.newWindow },
    },
    [
      !_vm.isRoomMode(["call", "group"]) &&
      !_vm.newWindow &&
      !_vm.Device.isMobile()
        ? _c("RoomCall", {
            attrs: {
              secondVideo: _vm.isRoomMode(["screenShare"]),
              videoOnly: true,
              pip: true,
            },
          })
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "room-extend-menu",
          class: { showSection: !_vm.showChatSection },
        },
        [
          _c(
            "div",
            { staticClass: "room-extend-menu-contents" },
            [
              _c("div", { staticClass: "room-extend-menu-header" }, [
                _c(
                  "div",
                  { staticClass: "room-extend-menu-tab-list-wrapper" },
                  [
                    _c("ul", { staticClass: "room-extend-menu-tab-list" }, [
                      _c("li", { staticClass: "room-extend-menu-tab-item" }, [
                        _c(
                          "button",
                          {
                            staticClass: "room-extend-menu-tab-button chat",
                            class: [
                              { selected: _vm.extendMenuTabType === "chat" },
                              { showBadge: _vm.unreadChat },
                            ],
                            on: {
                              click: function ($event) {
                                return _vm.onSelectExtendMenuType("chat")
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(_vm.$t("common.chat")) + " ")]
                        ),
                      ]),
                      _vm.useParticipantList
                        ? _c(
                            "li",
                            { staticClass: "room-extend-menu-tab-item" },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "room-extend-menu-tab-button",
                                  class: {
                                    selected:
                                      _vm.extendMenuTabType === "participants",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onSelectExtendMenuType(
                                        "participants"
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.$t("common.participant"))
                                  ),
                                  _c(
                                    "span",
                                    { staticClass: "room-user-count" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.filteredParticipants.length)
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]),
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "room-extend-menu-more-button-wrapper" },
                  [
                    _c("button", {
                      staticClass: "room-extend-menu-more-button",
                      on: { click: _vm.onToggleExtendMenuMoreList },
                    }),
                    _c("GrmMenu", {
                      attrs: {
                        "text-align": "left",
                        open: _vm.isOpenExtendMenuMoreList,
                        list: _vm.extendMenuMoreList,
                      },
                      on: {
                        "update:open": function ($event) {
                          _vm.isOpenExtendMenuMoreList = $event
                        },
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _c(
                "div",
                { staticClass: "room-extend-menu-body" },
                [
                  _c("RoomChat", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.extendMenuTabType === "chat",
                        expression: "extendMenuTabType === 'chat'",
                      },
                    ],
                    ref: "chat",
                    attrs: {
                      extendMenuTabType: _vm.extendMenuTabType,
                      newWindow: _vm.newWindow,
                      chatHistoryProp: _vm.chatHistoryProp,
                    },
                    on: { onChangeSection: _vm.onChangeSection },
                  }),
                  _c("ParticipantList", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.extendMenuTabType === "participants",
                        expression: "extendMenuTabType === 'participants'",
                      },
                    ],
                  }),
                ],
                1
              ),
              _c("RoomExtendMenuSection", {
                attrs: { section: _vm.section, newWindow: _vm.newWindow },
                on: { onChangeSection: _vm.onChangeSection },
              }),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }